import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type StaticListFilter } from '../types/filters';

export const OVERALL_RATING_OPTIONS = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
];

export const overallRatingDefinition: FilterDefinition<StaticListFilter> = {
  id: FilterId.OVERALL_RATING,
  name: 'Overall Rating',
  selections: [],
  type: FilterType.STATIC_LIST,
  isVisible: true,
};

export const overallRatingHandler: FilterHandler<StaticListFilter> = {
  isActive(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: StaticListFilter) {
    return { ...currentFilterState };
  },
};
